// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"biRC9 DIwTU a8cCT"};